export enum EventTypes {
  Download,
  Support,
  LoginOption,
}
